<template>
  <b-container fluid class="mt-5">
    <b-modal
      centered
      size="lg"
      id="modal-channels"
      hide-footer
      :title="`Cadastro de ${origin}`"
    >
      <b-container @submit.prevent="submitButton" tag="form">
        <b-row v-if="origin === 'canal'">
          <b-col cols="6">
            <input
              type="text"
              class="form-control mt-15"
              placeholder="Nome do canal"
              required
              v-model="form.channelname"
            />
          </b-col>
          <b-col cols="6">
            <app-select
              :data="{
                class: ['mt-15'],
                options: typesChannel,
                valueDefault: 'Tipo de canal',
                required: true,
              }"
              v-model="form.channeltype"
            />
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="7">
            <app-select
              :data="{
                class: ['my-15'],
                options: selectChannels,
                valueDefault: 'Canais',
                required: true,
              }"
              v-model="form.id"
            />
          </b-col>
          <b-col cols="12">
            <textarea
              rows="10"
              class="w-100"
              v-model="form.message"
              placeholder="Mensagens"
              style="
                resize: none;
                border: 1px solid #ced4da;
                border-radius: 0.25rem;
                border-width: 2px;
              "
            ></textarea>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mt-3 d-flex justify-content-end">
            <b-button
              variant="outline-warning"
              @click="$bvModal.hide('modal-channels')"
            >
              <i class="fa fa-ban" aria-hidden="true"></i>
              Cancelar</b-button
            >
            <b-button variant="outline-primary" type="submit" class="ml-2">
              <i class="fa fa-plus mr-1" aria-hidden="true"></i>Salvar</b-button
            >
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-row>
      <b-col cols="12">
        <h4 class="f-default">Gerenciar Canais</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="4">
        <app-info-card
          :data="{
            title: 'Quantidade de canais',
            content: channels.length,
          }"
        />
      </b-col>
      <b-col cols="12" md="4">
        <app-info-card
          :data="{
            title: 'Quantidade de Mensagens',
            content: messages,
          }"
        />
      </b-col>
      <b-col cols="12" md="4">
        <b-card class="btns-actions">
          <b-row class="h-100">
            <b-col cols="6">
              <b-button
                class="h-100 w-100"
                variant="outline-secondary"
                @click="
                  origin = 'canal';
                  $bvModal.show('modal-channels');
                "
              >
                <img
                  src="@/assets/img/svgs/add_2.svg"
                  height="30"
                  class="mb-1"
                />
                <br />
                Canal
              </b-button>
            </b-col>
            <b-col cols="6">
              <b-button
                class="h-100 w-100"
                variant="outline-secondary"
                @click="
                  origin = 'mensagem';
                  $bvModal.show('modal-channels');
                "
              >
                <img
                  src="@/assets/img/svgs/add_2.svg"
                  height="30"
                  class="mb-1"
                />
                <br />
                Mensagem
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="py-3">
      <b-col cols="12" md="3" offset="3">
        <b-form-input placeholder="Nome do canal" v-model="search" />
      </b-col>
      <b-col cols="12" md="3">
        <app-select
          :data="{
            options: typesChannel,
            valueDefault: 'Tipo de canal',
            required: true,
          }"
          v-model="typeChannel"
        />
      </b-col>

      <b-col cols="6" md="3" class="d-flex justify-content-center">
        <b-button variant="secondary" class="w-50 mr-1" @click="cleanFn"
          >Limpar</b-button
        >

        <b-button variant="primary" @click="searchFn" class="w-50"
          >Pesquisar</b-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" v-for="(item, index) in filteredChannels" :key="index">
        <app-acordeon :data="item" :is-table="false" :new-class="['pl-3']">
          <template #middle>
            <b-row no-gutters>
              <b-col cols="8">
                <p class="f-default">
                  <strong>  tipo: </strong>
                 {{ item.channeltype }} 
                </p>
              </b-col>
              <b-col cols="4">
                <p class="f-default">  <strong> quantidade: </strong> 0</p></b-col>
            </b-row>
          </template>
        </app-acordeon>
      </b-col>
      <b-col cols="12" class="d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-number
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import appInfoCard from "@/components/_infoCard";
import appAcordeon from "@/components/lokiDashboard/_accordeon";
import { mixins } from "@/mixins/mixins";
import api from "@/services/api";

export default {
  components: {
    appInfoCard,
    appAcordeon,
  },
  mixins: [mixins],
  data() {
    return {
      perPage: 5,
      rows: 0,
      currentPage: 1,
      form: {},
      origin: "",
      range: "",
      search: "",
      typeChannel: "",
      masks: {
        input: "DD/MM/YYYY",
      },
      item: {
        id: "channel",
        title: "Canal",
        table: {
          fields: [
            { key: "id", label: "ID" },
            { key: "name", label: "Name" },
            { key: "createdAt", label: "Created" },
            { key: "closedAt", label: "Closed" },
            { key: "status", label: "Status" },
          ],
          items: [],
        },
        isButton: false,
      },
      channels: [],
      selectChannels: [],
      typesChannel: [],
      filteredChannels: [],
      paginate: {
        start: 0,
        end: 5,
        bkp: 0,
      },
      messages:0
    };
  },
  watch: {
    currentPage() {
      if (this.currentPage === 1) {
        this.paginate["start"] = 0;
        this.paginate["end"] = 5;
        this.paginate["bkp"] = 0;
        this.filteredChannels = this.channels.slice(
          this.paginate["start"],
          this.paginate["end"]
        );
      } else {
        if (this.currentPage > this.paginate["bkp"]) {
          this.paginate["bkp"] = this.currentPage;
          this.paginate["start"] = this.paginate["end"];
          this.paginate["end"] += 5;
          this.filteredChannels = this.channels.slice(
            this.paginate["start"],
            this.paginate["end"]
          );
        } else {
          this.paginate["start"] -= 5;
          this.paginate["end"] -= 5;
          this.filteredChannels = this.channels.slice(
            this.paginate["start"],
            this.paginate["end"]
          );
        }
      }
    },
  },
  mounted() {
    this.getInformation();
  },
  methods: {
    searchFn() {},
    cleanFn() {
      this.search = "";
      this.range = "";
    },

    getInformation() {
      this.getAll();
      this.getTypes();
      this.getMessages();
    },
    async getMessages() {
      try {
        const { data } = await api.countMessageChannels();
        this.messages = data
      } catch (error) {
        this.errorCatch(error);
      }
    },
    async submitButton() {
      this.$store.commit("utils/setLoading", true);
      try {
        if (this.origin === "canal") {
          await api.addChannelLoki(this.form);
          this.getAll();
        } else {
          await api.addMessageLoki(this.form);
        }
        this.form = {};
        this.$bvModal.hide("modal-channels");
      } catch (error) {
        this.errorCatch(error);
      } finally {
        this.$store.commit("utils/setLoading", false);
      }
    },
    async getTypes() {
      try {
        const { data } = await api.typesChannelsLoki();
        this.typesChannel = data.map((mp) => {
          return {
            value: mp,
            text: mp,
          };
        });
      } catch (error) {
        this.errorCatch(error);
      }
    },
    async getAll() {
      this.$store.commit("utils/setLoading", true);
      try {
        const { data } = await api.managementChannelLoki();
        this.channels = data.map((mp) => {
          return {
            ...mp,
            title: mp.channelname,
            isButton: false,
          };
        });
        this.selectChannels = data.map((mp) => {
          return {
            value: mp.channelid,
            text: mp.channelname,
          };
        });
        this.filteredChannels = this.channels.slice(
          this.paginate["start"],
          this.paginate["end"]
        );
        this.rows = this.channels.length;
      } catch (error) {
        this.errorCatch(error);
      } finally {
        this.$store.commit("utils/setLoading", false);
      }
    },
  },
};
</script>
<style lang="scss">
.btns-actions {
  border: none !important;
  height: 101px;
}
</style>